import { Spin } from "antd";
import React from "react";
import { cn } from "@/utils/functions";
import { useTranslation } from "react-i18next";

function Loader({ className }) {
  const { t } = useTranslation();
  return (
    <div
      className={cn("h-screen flex justify-center items-center", {
        [className]: className,
      })}
    >
      <div className=" flex flex-col justify-center">
        <Spin size="large" />
        <h5 className="pt-2"> {t("common.loadingWait")}</h5>
      </div>
    </div>
  );
}

export default Loader;
